export default (x) => {
    return Math.ceil(x / 1) * 1;
};
